import { SupportThreadView } from './SupportThreadView';
import { useSupportThreadHeaderProps } from './useSupportThreadHeaderProps';

import { ChatWebContentHeader } from '@/components/chat/ChatHeaderContent';
import { VStack } from '@/components/ui/vstack';

/**
 * The support thread in the desktop inbox's chat column: the inquiry chat's
 * own content header, naming the other party, over the shared thread view.
 */
export function SupportThreadPane({ conversationId }: { conversationId: string }) {
  const headerProps = useSupportThreadHeaderProps(conversationId);

  return (
    <VStack className="flex-1 bg-background-50">
      <ChatWebContentHeader {...headerProps} />

      <SupportThreadView key={conversationId} conversationId={conversationId} />
    </VStack>
  );
}
